/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { configureStore, combineReducers } from '@reduxjs/toolkit';

// Use dynamic imports with type casting to avoid TypeScript errors
const ReduxPersist: any = require('redux-persist');
const ReduxPersistStorage: any = require('redux-persist/lib/storage');

const { persistReducer, persistStore } = ReduxPersist;
const storage = ReduxPersistStorage.default;

import userReducer from './slices/userSlice';
import productReducer from './slices/productSlice';
import customerReducer from './slices/customerSlice';
import opportunityReducer from './slices/opportunitySlice';
import quoteReducer from './slices/quoteSlice';
import orderReducer from './slices/orderSlice';
import { UserState } from './slices/userSlice';

// Define the root state type
export interface RootState {
  user: UserState;
  products: ReturnType<typeof productReducer>;
  customers: ReturnType<typeof customerReducer>;
  opportunities: ReturnType<typeof opportunityReducer>;
  quotes: ReturnType<typeof quoteReducer>;
  orders: ReturnType<typeof orderReducer>;
}

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // Only persist user state
};

const rootReducer = combineReducers({
  user: userReducer,
  products: productReducer,
  customers: customerReducer,
  opportunities: opportunityReducer,
  quotes: quoteReducer,
  orders: orderReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
